import { FC } from 'react';
import classnames from 'classnames';

import { FormHelperProps } from '@hh.ru/magritte-ui-form-helper/types';
import { useFormHelperAnimation } from '@hh.ru/magritte-ui-form-helper/useFormHelperAnimation';
import { Text } from '@hh.ru/magritte-ui-typography';

import styles from './form-helper.less';

export const FormHelperRenderer: FC<
    Pick<FormHelperProps, 'errorMessage' | 'description' | 'data-qa' | 'disabled' | 'topSpacing' | 'descriptionId'> & {
        errorMessageVisible: boolean;
        descriptionVisible: boolean;
    }
> = ({
    description,
    errorMessage,
    'data-qa': dataQa = 'form-helper-container',
    errorMessageVisible,
    descriptionVisible,
    disabled,
    topSpacing = 8,
    descriptionId,
}) => {
    const { helperRef, descriptionRef, errorMessageRef } = useFormHelperAnimation({
        descriptionVisible,
        errorMessageVisible,
        errorMessage,
        description,
        styles,
    });

    if (!description && !errorMessage) {
        return null;
    }

    return (
        <div
            className={classnames(styles.container, {
                [styles.disabled]: disabled,
            })}
            ref={helperRef}
            data-qa={dataQa}
        >
            {!!errorMessage && (
                <div
                    ref={errorMessageRef}
                    className={`${styles.formHelper} ${styles.formHelperError}`}
                    style={{ paddingTop: topSpacing }}
                    data-qa="form-helper-error"
                >
                    <Text typography="label-3-regular">
                        <div className={styles.formHelperTextWrapper}>{errorMessage}</div>
                    </Text>
                </div>
            )}
            {!!description && (
                <div
                    id={descriptionId}
                    ref={descriptionRef}
                    className={styles.formHelper}
                    style={{ paddingTop: topSpacing }}
                    data-qa="form-helper-description"
                >
                    <Text typography="label-3-regular">
                        <div className={styles.formHelperTextWrapper}>{description}</div>
                    </Text>
                </div>
            )}
        </div>
    );
};
